import { gql } from "@apollo/client";

export const LIST_CYCLES = gql`
  query listCyclesPaginated($filter: CycleFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listCyclesPaginated(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        startDate
        endDate
        limitDate
        isActive
        id
      }
      totalCount
    }
  }
`;

export const GET_CYCLE_FROM_DATE = gql`
  query getCycleFromDate($filter: CycleFromDateFilter!) {
    getCycleFromDate(filter: $filter) {
      startDate
      endDate
      limitDate
      isActive
      id
    }
  }
`;

export const GET_LOCATIONS_LIST = gql`
  query listLocations(
    $search: String
    $postalCode: String
    $city: String
    $countryCode: ID
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listLocations(
      filter: {
        search: $search
        postalCode_Startswith: $postalCode
        city_Icontains: $city
        countryId: $countryCode
      }
    ) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        postalCode
        city
        country {
          code
          name
        }
      }
    }
  }
`;

export const LIST_COUNTRIES_QUERY = gql`
  query listCountriesPaginated($search: String, $limit: Int, $offset: Int) {
    listCountriesPaginated(filter: { name_Unaccent_Istartswith: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: "name") {
        code
        name
      }
    }
  }
`;

export const LIST_LEGAL_STRUCTURES = gql`
  query listLegalStructures(
    $filter: LegalStructureFilter
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listLegalStructures(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        name
        code
        country {
          code
          name
        }
      }
    }
  }
`;

export const LIST_LEGAL_CATEGORIES = gql`
  query listLegalCategories($search: String, $limit: Int, $offset: Int, $orderBy: [String]) {
    listLegalCategories(filter: { search: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        code
        name
      }
    }
  }
`;

export const LIST_CYCLES_PAGINATED = gql`
  query listCyclesPaginated($filter: CycleFilterInput!, $company: ID!) {
    listCyclesPaginated(filter: $filter) {
      totalCount
      results {
        id
        startDate
        endDate
        limitDate
      }
    }
    getCurrentCycle(company: $company) {
      id
      startDate
      endDate
      limitDate
      isActive
    }
  }
`;

export const LIST_BOOKS_PAGINATED = gql`
  query listBooksPaginated(
    $filter: BookFilterInput
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listBooksPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        code
        name
      }
    }
  }
`;

export const GET_ACCOUNTING_FIRM = gql`
  query ($accountingFirmId: ID!) {
    getAccountingFirm(id: $accountingFirmId) {
      id
      name
    }
  }
`;

export const LIST_SUBSIDIARIES = gql`
  query listSubsidiaries($filter: SubsidiaryFilter) {
    listSubsidiaries(filter: $filter) {
      results {
        id
        name
        description
        code
      }
    }
  }
`;
